import { IconMetaData } from "../icon/types";

export interface IconLibMetaData extends IconMetaData {
    /** Keywords used in the icon-library filter */
    keywords: string[];
    /** Categories used in the icon-library filter */
    categories: string[];
    /** Description shown in the icon-library */
    description: string;
}

export interface IconLibFilters {
    directSearch: string;
    weight: string[];
    type: string[];
    keywords: string[];
    categories: string[];
}

export interface IconThumbnail {
    iconName: string;
    iconDescription: string;
    iconWeight: string;
    filled: boolean;
    key?: string;
}
